export interface Comic {
  id: number;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  desc: string;
  latestChapter: string;
  updateTime: string;
  status: string;
  rating: number;
  views: string;
  followers: number;
  cover: string;
}

export const genres = [
  { name: "玄幻", icon: "ri-sword-line", color: "primary", count: 326 },
  { name: "恋爱", icon: "ri-heart-3-line", color: "accent", count: 284 },
  { name: "热血", icon: "ri-fire-line", color: "secondary", count: 218 },
  { name: "悬疑", icon: "ri-ghost-line", color: "primary", count: 156 },
  { name: "科幻", icon: "ri-rocket-2-line", color: "accent", count: 142 },
  { name: "都市", icon: "ri-building-line", color: "secondary", count: 198 },
  { name: "校园", icon: "ri-school-line", color: "primary", count: 173 },
  { name: "搞笑", icon: "ri-emotion-laugh-line", color: "accent", count: 121 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "逆鳞之刃",
    author: "金泰浩",
    genre: "玄幻",
    tags: ["爽文", "复仇", "龙族"],
    desc: "被废去灵根的少年林彻，在绝境中觉醒远古龙族血脉，以一把逆鳞短刃踏上复仇与登顶之路。",
    latestChapter: "第286话 觉醒",
    updateTime: "今天 09:20",
    status: "连载中",
    rating: 9.2,
    views: "2.1亿",
    followers: 126000,
    cover: "https://comtock.github.io/api/search-image?query=vibrant%20webtoon%20cover%20illustration%20of%20a%20young%20swordsman%20with%20a%20crimson%20dragon%20spirit%2C%20dark%20fantasy%20style%2C%20dramatic%20lighting%2C%20clean%20comic%20artwork%20with%20bold%20colors%20and%20strong%20composition&width=600&height=800&seq=cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "星辰契约",
    author: "朴智恩",
    genre: "恋爱",
    tags: ["奇幻", "青梅竹马", "宫廷"],
    desc: "失忆的占星少女与守护王城的骑士之间，围绕星辰预言展开的一段跨越身份的爱恋。",
    latestChapter: "第164话 星陨之夜",
    updateTime: "今天 09:12",
    status: "连载中",
    rating: 9.0,
    views: "1.6亿",
    followers: 98000,
    cover: "https://comtock.github.io/api/search-image?query=romantic%20fantasy%20webtoon%20cover%20illustration%20of%20an%20astrologer%20girl%20with%20glowing%20stars%20and%20a%20royal%20knight%2C%20dreamy%20soft%20colors%2C%20clean%20manhwa%20artwork%2C%20elegant%20composition%20with%20night%20sky%20background&width=600&height=800&seq=cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "灰烬重生",
    author: "李承勋",
    genre: "末世",
    tags: ["末日", "进化", "生存"],
    desc: "世界崩塌后，重生者韩澈带着上一世的记忆重新走上猎杀怪物的道路，这一次他绝不再重蹈覆辙。",
    latestChapter: "第203话 黎明前夕",
    updateTime: "今天 08:55",
    status: "连载中",
    rating: 9.4,
    views: "2.8亿",
    followers: 154000,
    cover: "https://comtock.github.io/api/search-image?query=post-apocalyptic%20webtoon%20cover%20of%20a%20determined%20hunter%20with%20a%20glowing%20blade%20facing%20ruined%20city%20skyline%2C%20moody%20atmospheric%20lighting%2C%20bold%20manhwa%20art%2C%20dramatic%20cinematic%20composition&width=600&height=800&seq=cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "钢铁之心",
    author: "郑敏浩",
    genre: "科幻",
    tags: ["机甲", "战斗", "未来"],
    desc: "废弃机甲驾驶员与AI少女搭档，在火星殖民地阴谋中一路逆袭，找回人类失落的勇气。",
    latestChapter: "第178话 暴走核心",
    updateTime: "今天 08:40",
    status: "连载中",
    rating: 8.8,
    views: "1.2亿",
    followers: 76000,
    cover: "https://comtock.github.io/api/search-image?query=futuristic%20mecha%20webtoon%20cover%20illustration%20of%20a%20pilot%20with%20a%20giant%20robot%20and%20holographic%20AI%20girl%2C%20sci-fi%20blue%20steel%20tones%2C%20clean%20manhwa%20artwork%2C%20dynamic%20action%20composition&width=600&height=800&seq=cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "月下秘闻",
    author: "韩素英",
    genre: "悬疑",
    tags: ["推理", "惊悚", "都市"],
    desc: "私家侦探沈默月追查连环失踪案，却发现每个线索都指向十年前那桩被刻意掩盖的旧案。",
    latestChapter: "第96话 面具之下",
    updateTime: "今天 08:25",
    status: "连载中",
    rating: 9.1,
    views: "8900万",
    followers: 64000,
    cover: "https://comtock.github.io/api/search-image?query=noir%20mystery%20webtoon%20cover%20of%20a%20detective%20under%20moonlight%20with%20a%20dark%20city%20alley%2C%20suspenseful%20atmosphere%2C%20deep%20shadows%2C%20clean%20manhwa%20illustration%20with%20moon%20motif&width=600&height=800&seq=cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "校园风云",
    author: "崔允儿",
    genre: "校园",
    tags: ["青春", "热血", "友情"],
    desc: "转学少年徐在亨意外卷入全校社团之争，用一场场热血的校园对决赢得尊重与友情。",
    latestChapter: "第132话 最终决赛",
    updateTime: "昨天 22:40",
    status: "连载中",
    rating: 8.7,
    views: "1.0亿",
    followers: 81000,
    cover: "https://comtock.github.io/api/search-image?query=energetic%20high%20school%20webtoon%20cover%20of%20confident%20students%20in%20uniforms%20under%20cherry%20blossoms%2C%20bright%20vibrant%20colors%2C%20clean%20manhwa%20artwork%2C%20youthful%20dynamic%20composition&width=600&height=800&seq=cover-06&orientation=portrait",
  },
  {
    id: 7,
    title: "御灵师",
    author: "文正焕",
    genre: "玄幻",
    tags: ["捉妖", "成长", "伙伴"],
    desc: "平凡的灵馆学徒陆小川，在一只傲娇九尾狐灵的陪伴下，逐步揭开上古灵界封印的秘密。",
    latestChapter: "第251话 灵界之门",
    updateTime: "昨天 21:58",
    status: "连载中",
    rating: 9.3,
    views: "1.9亿",
    followers: 118000,
    cover: "https://comtock.github.io/api/search-image?query=fantasy%20spirit%20master%20webtoon%20cover%20with%20a%20young%20exorcist%20and%20a%20nine-tailed%20fox%20spirit%2C%20mystical%20glowing%20runes%2C%20vibrant%20oriental%20fantasy%20style%2C%20clean%20manhwa%20artwork%20with%20magical%20background&width=600&height=800&seq=cover-07&orientation=portrait",
  },
  {
    id: 8,
    title: "绯色恋歌",
    author: "姜美娜",
    genre: "恋爱",
    tags: ["娱乐圈", "契约", "甜宠"],
    desc: "过气歌星与当红偶像签订假恋爱契约，一场场绯闻炒作之下，两人的心却悄悄靠近。",
    latestChapter: "第78话 契约之外",
    updateTime: "昨天 21:10",
    status: "连载中",
    rating: 8.9,
    views: "9500万",
    followers: 72000,
    cover: "https://comtock.github.io/api/search-image?query=glamorous%20entertainment%20romance%20webtoon%20cover%20of%20a%20female%20singer%20and%20male%20idol%20on%20a%20stage%2C%20warm%20rose%20and%20gold%20tones%2C%20clean%20manhwa%20artwork%2C%20soft%20romantic%20composition%20with%20spotlights&width=600&height=800&seq=cover-08&orientation=portrait",
  },
];

export const hotRanking = [
  { id: 3, title: "灰烬重生", genre: "末世", rise: 2, chapter: "第203话", cover: "https://comtock.github.io/api/search-image?query=post-apocalyptic%20webtoon%20cover%20of%20a%20hunter%20with%20glowing%20blade%20against%20ruined%20skyline%2C%20moody%20atmospheric%20manhwa%20art%2C%20dramatic%20lighting&width=600&height=800&seq=rank-01&orientation=portrait" },
  { id: 1, title: "逆鳞之刃", genre: "玄幻", rise: 1, chapter: "第286话", cover: "https://comtock.github.io/api/search-image?query=dark%20fantasy%20webtoon%20cover%20of%20young%20swordsman%20with%20crimson%20dragon%20spirit%2C%20bold%20manhwa%20art%2C%20dramatic%20composition&width=600&height=800&seq=rank-02&orientation=portrait" },
  { id: 7, title: "御灵师", genre: "玄幻", rise: -1, chapter: "第251话", cover: "https://comtock.github.io/api/search-image?query=fantasy%20spirit%20master%20webtoon%20cover%20young%20exorcist%20nine-tailed%20fox%2C%20mystical%20oriental%20fantasy%20manhwa%20art&width=600&height=800&seq=rank-03&orientation=portrait" },
  { id: 5, title: "月下秘闻", genre: "悬疑", rise: 3, chapter: "第96话", cover: "https://comtock.github.io/api/search-image?query=noir%20mystery%20webtoon%20cover%20detective%20under%20moonlight%20dark%20city%2C%20suspenseful%20manhwa%20illustration&width=600&height=800&seq=rank-04&orientation=portrait" },
  { id: 2, title: "星辰契约", genre: "恋爱", rise: 0, chapter: "第164话", cover: "https://comtock.github.io/api/search-image?query=romantic%20fantasy%20webtoon%20cover%20astrologer%20girl%20royal%20knight%20night%20sky%2C%20dreamy%20manhwa%20artwork&width=600&height=800&seq=rank-05&orientation=portrait" },
  { id: 4, title: "钢铁之心", genre: "科幻", rise: -2, chapter: "第178话", cover: "https://comtock.github.io/api/search-image?query=sci-fi%20mecha%20webtoon%20cover%20pilot%20robot%20AI%20girl%2C%20blue%20steel%20tones%20manhwa%20art%2C%20dynamic%20action&width=600&height=800&seq=rank-06&orientation=portrait" },
];

export const testimonials = [
  { name: "追更小树洞", role: "追更2年", avatar: "https://comtock.github.io/api/search-image?query=cute%20minimal%20avatar%20illustration%20of%20a%20tree%20with%20a%20smile%2C%20flat%20vector%20style%2C%20warm%20colors&width=200&height=200&seq=avatar-01&orientation=squarish", text: "设置追更提醒之后真的不会错过任何一话，每天打开首页就知道今天要看什么，太省心了。" },
  { name: "奶茶三分甜", role: "追更3年", avatar: "https://comtock.github.io/api/search-image?query=cute%20minimal%20avatar%20illustration%20of%20a%20milk%20tea%20cup%20with%20a%20smile%2C%20flat%20vector%20style%2C%20soft%20pink&width=200&height=200&seq=avatar-02&orientation=squarish", text: "更新速度很快，热门韩漫基本都是第一时间同步，追更体验非常流畅，强烈推荐给同好。" },
  { name: "追番小迷妹", role: "追更1年", avatar: "https://comtock.github.io/api/search-image?query=cute%20minimal%20avatar%20illustration%20of%20a%20cat%20with%20glasses%20reading%2C%20flat%20vector%20style%2C%20mint%20green&width=200&height=200&seq=avatar-03&orientation=squarish", text: "分类很清晰，想看恋爱、热血还是悬疑都能快速找到，首页推荐也都很对我口味。" },
  { name: "秃头看漫人", role: "追更5年", avatar: "https://comtock.github.io/api/search-image?query=cute%20minimal%20avatar%20illustration%20of%20a%20panda%20holding%20a%20book%2C%20flat%20vector%20style%2C%20warm%20orange&width=200&height=200&seq=avatar-04&orientation=squarish", text: "从老站追过来的老用户，这里的榜单真实、更新稳定，追更提醒也做得越来越贴心了。" },
];

export const faqs = [
  {
    q: "韩国漫画yy每天几点更新？",
    a: "韩国漫画yy每日定时更新连载内容，一般集中在上午时段完成同步，热门韩漫通常会在当天上午发布最新章节，你也可以设置追更提醒，第一时间收到更新通知。",
  },
  {
    q: "如何设置追更提醒不遗漏更新？",
    a: "在任意作品详情页点击「追更」按钮并开启提醒，当该作品更新新章节时，你会第一时间收到通知；同时可以订阅每日更新推送，把所有追更作品的更新汇总到一封提醒里。",
  },
  {
    q: "首页的今日更新列表是自动生成的吗？",
    a: "是的，今日更新板块会根据全站作品的更新时间自动整理排序，刚更新的作品会排在前面，方便你一眼看全今天所有值得看的新内容。",
  },
  {
    q: "为什么有些作品显示'已完结'？",
    a: "连载中的作品会标注「连载中」，已完结的作品则标注「已完结」，方便你根据追更习惯筛选。已完结作品同样可以在追更列表里管理，不会丢失阅读进度。",
  },
  {
    q: "追更数据会丢失吗？",
    a: "不会。你的追更列表、阅读进度和提醒设置都会自动保存，更换设备登录同一账号后也能同步，随时随地接着追。",
  },
  {
    q: "怎么反馈更新异常或建议新增功能？",
    a: "你可以通过页面底部的订阅/联系表单给我们留言，或关注站内公告了解最新动态，我们会定期收集用户反馈并持续优化追更体验。",
  },
];

export const stats = [
  { label: "收录作品", value: "1200+" },
  { label: "每日更新", value: "80+" },
  { label: "注册追更用户", value: "35万+" },
  { label: "累计同步章节", value: "9.6万+" },
];